import { Columns } from "components/elements"
import React, { Component } from "react"
import {
  CLOUDINARY_NAME,
  CLOUDINARY_DOCUMENTS_PRESET,
  CLOUDINARY_API_KEY
} from "../../../constants/images/cloudinary"
import { apiProcess } from "../../api/api.js"
import "./cardTrigger.css"
class InsuranceCardInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      generalError: false,
      insuranceBack: this.props.insuranceBack,
      insuranceFront: this.props.insuranceFront,
      insuranceBackID: this.props.insuranceBackID,
      insuranceFrontID: this.props.insuranceFrontID,
      insuranceBackThumbnail: this.props.insuranceBackThumbnail,
      insuranceFrontThumbnail: this.props.insuranceFrontThumbnail,
      insuranceError: false,
      targetSide: null
    }
    this.cloudWidget = window.cloudinary?.createUploadWidget(
      {
        cloudName: CLOUDINARY_NAME,
        apiKey: CLOUDINARY_API_KEY,
        uploadSignature: this.makeCloudinarySignature,
        uploadPreset: CLOUDINARY_DOCUMENTS_PRESET,
        sources: ["local"],
        showAdvancedOptions: false,
        //cropping: false,
        //croppingShowBackButton : false,
        //croppingAspectRatio : 1.65,
        //croppingDefaultSelectionRatio :  .85,
        multiple: false,
        defaultSource: "local",

        styles: {
          palette: {
            window: "#ffffff",
            sourceBg: "#f4f4f5",
            windowBorder: "#90a0b3",
            tabIcon: "#000000",
            inactiveTabIcon: "#555a5f",
            menuIcons: "#555a5f",
            link: "#B9995A",
            action: "#339933",
            inProgress: "#0433ff",
            complete: "#339933",
            error: "#cc0000",
            textDark: "#000000",
            textLight: "#fcfffd"
          },
          fonts: {
            default: null,
            "sans-serif": {
              url: null,
              active: true
            }
          }
        }
      },
      (err, result) => {
        if (!err) {
          if (result.event === "success") {
            if (this.state.targetSide === "front") {
              this.setState({ insuranceFront: result.info.secure_url })
              this.setState({ insuranceFrontID: result.info.public_id })
              this.setState({ insuranceFrontThumbnail: result.info.secure_url })
              this.props.onChange(
                "front",
                result.info.secure_url,
                result.info.public_id
              )
            } else {
              this.setState({ insuranceBack: result.info.secure_url })
              this.setState({ insuranceBackID: result.info.public_id })
              this.setState({ insuranceBackThumbnail: result.info.secure_url })
              this.props.onChange(
                "back",
                result.info.secure_url,
                result.info.public_id
              )
            }
          }
        } else {
          this.setState({
            generalError:
              "Sorry, we are having upload issues right now. Please try again."
          })
        }
      }
    )
  }

  changeInsurance = side => {
    this.setState({ targetSide: side })
    this.cloudWidget.open()
  }

  makeCloudinarySignature = (callBack, paramsToSign) => {
    let apiURL = "media/images/secure_upload_token"

    let sigData = {
      params_to_sign: paramsToSign
    }

    apiProcess(
      apiURL,
      sigData,
      "cloudinary-signature",
      "Generate Cloudinary Upload Sig from Insurance Field"
    )
      .then(function(responseData) {
        callBack(responseData.cloudinary_signed_token)
      })
      .catch(function(responseData) {})
  }

  render() {
    const {
      generalError,
      insuranceBackThumbnail,
      insuranceFrontThumbnail
    } = this.state

    const { error } = this.props
    return (
      <React.Fragment>
        {generalError && <div className="mb-4">{generalError}</div>}
        <Columns className="is-vcentered">
          <Columns.Column>
            <button
              className="card-trigger-wrap"
              onClick={(e) => {
                this.changeInsurance("front")
                e.preventDefault()
              }}
            >
              {insuranceFrontThumbnail == null && (
                <div className="card-trigger-inside">
                  Front of Card
                  <span>+</span>
                </div>
              )}
              {insuranceFrontThumbnail !== null && (
                <React.Fragment>
                  <img
                    className="insurance-card-front-thumbnail"
                    src={insuranceFrontThumbnail}
                    alt="Insurance Card - Front"
                  />
                  <p className="field-sub-description">
                    <i className="fal fa-pencil-alt"></i>
                  </p>
                </React.Fragment>
              )}
            </button>
          </Columns.Column>
          <Columns.Column>
            <button
              className="card-trigger-wrap"
              onClick={(e) => {
                this.changeInsurance("back")
                e.preventDefault()
              }}
            >
              {insuranceBackThumbnail == null && (
                <div className="card-trigger-inside">
                  Back of Card
                  <span>+</span>
                </div>
              )}
              {insuranceBackThumbnail !== null && (
                <React.Fragment>
                  <img
                    className="insurance-card-back-thumbnail"
                    src={insuranceBackThumbnail}
                    alt="Insurance Card - Back"
                  />
                  <p className="field-sub-description">
                    <i className="fal fa-pencil-alt"></i>
                  </p>
                </React.Fragment>
              )}
            </button>
          </Columns.Column>
        </Columns>
        {error && (
          <div className="has-text-danger mt-4">
            You must upload front AND back images of your insurance cards.
          </div>
        )}
      </React.Fragment>
    )
  }
}
export default InsuranceCardInput

InsuranceCardInput.defaultProps = {
  insuranceBack: null,
  insuranceFront: null,
  insuranceBackID: null,
  insuranceFrontID: null,
  insuranceBackThumbnail: null,
  insuranceFrontThumbnail: null,
  error: false,
  showSubDescription: true,
  onChange: null
}
